import { StatusPage } from "@/components/status-page"
import { Button } from "@/components/ui/button"

export function GlobalErrorView({
  digest,
  onRetry,
}: {
  digest?: string
  onRetry: () => void
}) {
  return (
    <StatusPage
      data-component="global-error"
      title="Something went wrong"
      description="An unexpected error occurred. Please try again or contact support if the problem persists."
      action={
        <Button type="button" onClick={onRetry} data-testid="global-error-retry">
          Try again
        </Button>
      }
    >
      {digest ? <p className="font-code text-xs text-muted-foreground">Error ID: {digest}</p> : null}
    </StatusPage>
  )
}
